/**
 * Constants for Calendar module
 */

// CR-5459: three synthetic event types surfaced by the calendar list
// endpoint (Approval Expiry from SupplierProfile.next_audit_date,
// Contract Renewal from ContractPrice.valid_to, QBR from
// title-matched CalendarEvent rows). Colour palette picks high-contrast
// shades distinct from the existing 8 ad-hoc types: red for the
// approval-deadline warning, blue for the renewal heads-up, green for
// the strategic review.
export const EVENT_TYPE_COLORS: Record<string, string> = {
  meeting: 'bg-blue-500',
  deadline: 'bg-red-500',
  delivery: 'bg-green-500',
  audit: 'bg-purple-500',
  inspection: 'bg-yellow-500',
  review: 'bg-indigo-500',
  training: 'bg-pink-500',
  other: 'bg-gray-500',
  approval_expiry: 'bg-rose-600',
  contract_renewal: 'bg-sky-600',
  qbr: 'bg-emerald-600',
  // NCR-related event types (client feedback)
  ncr_response_due: 'bg-orange-500',
  ncr_car_due: 'bg-amber-600',
  action_due: 'bg-red-600',
  // Supplier audits and their actions (audits app, construction Phase 2)
  supplier_audit: 'bg-violet-700',
  audit_action: 'bg-fuchsia-600',
};

export const EVENT_TYPE_BG_COLORS: Record<string, string> = {
  meeting: '#3b82f6',
  deadline: '#ef4444',
  delivery: '#10b981',
  audit: '#a855f7',
  inspection: '#eab308',
  review: '#6366f1',
  training: '#ec4899',
  other: '#6b7280',
  approval_expiry: '#e11d48',
  contract_renewal: '#0284c7',
  qbr: '#059669',
  // NCR-related event types (client feedback)
  ncr_response_due: '#f97316',
  ncr_car_due: '#d97706',
  action_due: '#dc2626',
  supplier_audit: '#6d28d9',
  audit_action: '#c026d3',
};

export const EVENT_TYPE_LABELS: Record<string, string> = {
  meeting: 'Meeting',
  deadline: 'Deadline',
  delivery: 'Delivery',
  audit: 'Audit',
  inspection: 'Inspection',
  review: 'Review',
  training: 'Training',
  other: 'Other',
  approval_expiry: 'Approval Expiry',
  contract_renewal: 'Contract Renewal',
  qbr: 'Supplier QBR',
  // NCR-related event types (client feedback)
  ncr_response_due: 'NCR Response Due',
  ncr_car_due: 'Corrective Action Due',
  action_due: 'Action Due Date',
  supplier_audit: 'Supplier Audit',
  audit_action: 'Audit Action Due',
};

export const STATUS_COLORS: Record<string, string> = {
  scheduled: 'bg-blue-100 text-blue-800',
  in_progress: 'bg-yellow-100 text-yellow-800',
  completed: 'bg-green-100 text-green-800',
  cancelled: 'bg-red-100 text-red-800',
};

export const ALL_EVENT_TYPES = [
  'meeting',
  'deadline',
  'delivery',
  'audit',
  'inspection',
  'review',
  'training',
  'other',
  'approval_expiry',
  'contract_renewal',
  'qbr',
  // NCR-related event types (client feedback)
  'ncr_response_due',
  'ncr_car_due',
  'action_due',
  'supplier_audit',
  'audit_action',
];

export const ITEMS_PER_PAGE = 10;
